import VueClipboard from 'vue-clipboard2'

export default ({ app, router, Vue }) => {
    Vue.use(VueClipboard)
}
